import { mapGetters } from "vuex";
export default {
  computed: {
    google() {
      return this.getGoogle();
    },
    map() {
      return this.getMap();
    },
    googleMapsReady() {
      return this.google && this.map;
    },
  },
  methods: {
    ...mapGetters(["getGoogle", "getMap"]),
  },
};
